export default {"src":"/_next/static/media/diamons-stars-icon.d449f3dc.svg","height":31,"width":30};